/* eslint-disable */
import React, {
	forwardRef,
	useRef,
	useState,
	useCallback,
	useEffect,
	useImperativeHandle
} from 'react';
import cls from 'classnames';
import Img from '~/components/Elements/Img';
import ProgressRing from '~/components/ProgressRing';

export const V360Page = forwardRef(({
	className,
	classes,
	mobile,
	label,
	started,
	display,
	...props
}, ref) => {
	const rootRef = useRef();
	const [percentage, setPercentage] = useState(0);

	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// STARTUP
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	const setProgress = useCallback((percentage) => {
		setPercentage(percentage);
	});


	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	// RENDER
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	useImperativeHandle(ref, () => ({
		root: rootRef.current,
		progress: percentage,
		setProgress,
	}));

	return (
		<div
			{...props}
			ref={rootRef}
			className={cls(classes.root, className, {
				[classes.isDone]: started && !display,
				[classes.isWaiting]: !started,
			})}>

			<button className={classes.button}>
				<p
					className={classes.buttonLabel}
					dangerouslySetInnerHTML={{
						__html: label,
					}}
				/>
				<p className={classes.buttonAtivar}>Activar</p>
				
				<div className={classes.buttonIcon}>
					<Img
						className={classes.buttonIconImage}
						src={'/assets/images/360-laranja.png'}
						alt={label}
						width={61}
						height={61}
					/>
					<ProgressRing
						className={classes.buttonIconProgress}
						radius={90}
						stroke={10}
						progress={started && display ? percentage * 100 : 0}
					/>
				</div>

			</button>

		</div>
	);
});

export default V360Page;
